"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _material = require("@mui/material");
var _TypeRulePaymentFormsForm = _interopRequireDefault(require("./TypeRulePaymentFormsForm"));
var _TypeUsesForm = _interopRequireDefault(require("./TypeUsesForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function TypeRuleForm(_ref) {
  var data = _ref.data,
    onUpdated = _ref.onUpdated,
    onClose = _ref.onClose;
  var availableTabs = (0, _react.useMemo)(function () {
    if (data.type === 'I' || data.type === 'N') {
      return ['forms', 'uses'];
    }
    return ['uses'];
  }, [data]);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    tab = _useState2[0],
    setTab = _useState2[1];
  var _useState3 = (0, _react.useState)(data),
    _useState4 = _slicedToArray(_useState3, 2),
    request = _useState4[0],
    setRequest = _useState4[1];
  var onChangedUses = (0, _react.useCallback)(function (uses) {
    setRequest(function (curr) {
      return Object.assign(Object.assign({}, curr), {
        uses: uses
      });
    });
  }, []);
  var onChangedForms = (0, _react.useCallback)(function (paymentMethod, paymentForms) {
    setRequest(function (curr) {
      var newRules = curr.rules.map(function (el) {
        if (!paymentMethod || el.payment_method === paymentMethod) {
          return Object.assign(Object.assign({}, el), {
            payment_forms: paymentForms
          });
        }
        return el;
      });
      return Object.assign(Object.assign({}, curr), {
        rules: newRules
      });
    });
  }, []);
  var getTab = function getTab(tabId) {
    return /*#__PURE__*/_react["default"].createElement(_material.Tab, {
      key: tabId,
      label: (0, _core.translate)("rules.types.".concat(tabId))
    });
  };
  var getTabContent = function getTabContent(tabId, hidden) {
    switch (tabId) {
      case 'uses':
        return /*#__PURE__*/_react["default"].createElement(_TypeUsesForm["default"], {
          data: request,
          onChanged: onChangedUses
        });
      case 'forms':
        return /*#__PURE__*/_react["default"].createElement(_TypeRulePaymentFormsForm["default"], {
          data: request,
          onChanged: onChangedForms
        });
      default:
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, tabId);
    }
  };
  var handleUpdate = function handleUpdate() {
    if (availableTabs.indexOf('forms') < 0) {
      request.rules.forEach(function (paymentMethodRule) {
        paymentMethodRule.payment_forms = [];
      });
    }
    onUpdated(request);
  };
  var handleChange = function handleChange(event, newValue) {
    setTab(newValue);
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: (0, _core.translate)('rules.types.title', {
      type: (0, _core.translate)("cfdi.types.".concat(request.type))
    }),
    maxWidth: "md",
    fullWidth: true,
    button: {
      text: (0, _core.translate)('buttons.update'),
      onClick: handleUpdate
    },
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_material.Tabs, {
    value: tab,
    onChange: handleChange,
    variant: "scrollable"
  }, availableTabs.map(function (tabId) {
    return getTab(tabId);
  })), availableTabs.map(function (tabId, index) {
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      key: tabId,
      container: true,
      spacing: 3
    }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_material.Hidden, {
      xsUp: index !== tab,
      implementation: "css"
    }, getTabContent(tabId, index !== tab))));
  }));
}
var _default = exports["default"] = TypeRuleForm;